import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-products')) {
  pageSiteProducts()
}

function pageSiteProducts() {
  //   ####  ##      ##  ####    #####
  //  ##     ##      ##  ##  ##  ##
  //   ###   ##      ##  ##  ##  #####
  //     ##  ##      ##  ##  ##  ##
  //  ####   ######  ##  ####    #####

  if (document.getElementById('proSlide')) {
    // Swiperコンテナを検出したら実行
    const slideItem = document.getElementById('proSlide')
    const sliderName = 'proSlide'
    const proSlideSwiper = new Swiper(slideItem, {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
        renderBullet: function (index, className) {
          // bulletsの描画内容を改変

          const targetImage = document.querySelector('[data-swiper-slide-index="' + index + '"]').dataset.pager
          return (
            '<button type="button" class="' +
            className +
            '"><img src=" ' +
            targetImage +
            ' " alt="ページ' +
            index +
            '" /></button>'
          )
        },
      },
      on: {
        init: function () {
          // 初期化完了時のコールバック

          // ページャーにダミーを追加する
          setTimeout(() => {
            const dummyPager = document.createElement('div')
            dummyPager.classList.add('swiper-pagination-bullet')
            dummyPager.classList.add('dummy')
            const dummyPagerTarget = document.getElementById('slidePager')
            dummyPagerTarget.appendChild(dummyPager) // 最後の子要素として追加s
          }, 200)

          // YouTubeのsrcをdata属性にコピーする
          const slideYoutube = document.querySelectorAll('.swiper-slide iframe')
          for (const youtube of slideYoutube) {
            youtube.dataset.src = youtube.src
          }
        },
      },
    })

    proSlideSwiper.on('slideChangeTransitionStart', function () {
      // スライド時のトリガー

      // YouTubeの再生状態を切り替える
      const slideYoutube = document.querySelectorAll('.swiper-slide iframe')

      for (const youtube of slideYoutube) {
        const slide = youtube.parentNode
        if (slide.classList.contains('swiper-slide-active')) {
          youtube.src = youtube.dataset.src
        } else {
          youtube.src = ''
        }
      }
    })
  }

  //  ##   ##    ###    ##                 ####  ##    ##  ##     ##   ####
  //  ##   ##   ## ##   ##                ##      ##  ##   ####   ##  ##
  //  ##   ##  ##   ##  ##      ########   ###     ####    ##  ## ##  ##
  //   ## ##   #######  ##                   ##     ##     ##    ###  ##
  //    ###    ##   ##  ######            ####      ##     ##     ##   ####
  // カートに入れる数を全ての入力欄で同期する
  const valInput = document.getElementsByClassName('js-valSync')

  function cartValSync(e) {
    // 指定のクラスを確認
    if (!e.target.classList.contains('js-valSync')) {
      return
    }
    for (const iterator of valInput) {
      iterator.value = e.target.value
    }
  }
  if (valInput[0]) {
    window.addEventListener('input', function (e) {
      cartValSync(e)
    })
    window.addEventListener('change', function (e) {
      cartValSync(e)
    })
  }

  //   ####    ###    #####    ######
  //  ##      ## ##   ##  ##     ##
  //  ##     ##   ##  #####      ##
  //  ##     #######  ##  ##     ##
  //   ####  ##   ##  ##   ##    ##

  // let addToCartForm = document.querySelector('form[action$="/cart/add"]')
  // let formData = new FormData(addToCartForm)
  // fetch(window.Shopify.routes.root + 'cart/add.js', {
  //   method: 'POST',
  //   body: formData,
  // })
  //   .then((response) => {
  //     return response.json()
  //   })
  //   .catch((error) => {
  //     console.error('Error:', error)
  //   })

  //   #####   #####   ######  ##   #####   ##     ##
  //  ##   ##  ##  ##    ##    ##  ##   ##  ####   ##
  //  ##   ##  #####     ##    ##  ##   ##  ##  ## ##
  //  ##   ##  ##        ##    ##  ##   ##  ##    ###
  //   #####   ##        ##    ##   #####   ##     ##

  //             ####  #####  ######  ##   ##  #####
  //            ##     ##       ##    ##   ##  ##  ##
  //  ########   ###   #####    ##    ##   ##  #####
  //               ##  ##       ##    ##   ##  ##
  //            ####   #####    ##     #####   ##

  const observeItem = document.getElementById('baseForm')
  const observer = new MutationObserver((records) => {
    const item = records[0].target.querySelector('.ymq-attrib-ymq-variant-0:checked')

    if (!item) {
      return
    }
    applyOptionPrice(item) // 価格を反映

    observer.disconnect()
  })
  observer.observe(observeItem, {
    // 指定要素の変化を監視
    childList: true, // 子要素の監視
    // subtree: true, // 子孫要素の監視
    // attributes: true, // 属性の変化を監視
    // attributeFilter: ['style'], // 監視する属性を限定する場合は指定
    // characterData: true, // 文字の監視
  })

  //            #####   #####    ##   ####  #####
  //            ##  ##  ##  ##   ##  ##     ##
  //  ########  #####   #####    ##  ##     #####
  //            ##      ##  ##   ##  ##     ##
  //            ##      ##   ##  ##   ####  #####

  // 商品オプションの変更時、価格表示を切り替える

  // window.addEventListener('input', function (e) {
  //   if (!e.target.classList.contains('ymq-attrib-ymq-variant-0')) {
  //     return
  //   }
  //   applyOptionPrice(e.target) // 価格を反映
  //   syncOption(e.target) // セレクトボックスを同期
  // })
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('ymq-attrib-ymq-variant-0')) {
      return
    }
    applyOptionPrice(e.target) // 価格を反映
    // syncOption(e.target) // セレクトボックスを同期
  })
}

function applyOptionPrice(item) {
  /* global best_option */
  const productPrice = document.getElementById('price')
  const optionList = best_option.product.variants
  for (const key in optionList) {
    if (optionList[key].title.indexOf(item.value)) {
      continue
    }

    // 価格を取得
    // 小数2桁まで含めた値が整数で入っているので削る
    const price = optionList[key].price / 100

    productPrice.innerHTML = '&yen;' + price.toLocaleString()
    break
  }
}

function syncOption(item) {
  const selectList = document.getElementsByClassName('ymq-attrib-ymq-variant-0')
  const index = item.selectedIndex
  for (const select of selectList) {
    select.selectedIndex = index
  }
  syncOptionID() // オプションに対応する商品IDを同期
}

function syncOptionID() {
  setTimeout(() => {
    document.getElementById('subID').value = document.getElementById('mainID').value
  }, 200)
}
